import { defineComponent, resolveComponent, openBlock, createElementBlock, createElementVNode, createVNode, withCtx, withDirectives, normalizeClass, vShow, toDisplayString, renderSlot, createCommentVNode, ref, toRefs, watch, Fragment, renderList, vModelRadio, pushScopeId, popScopeId, createStaticVNode, createTextVNode, vModelDynamic, vModelText, createBlock } from 'vue';
import { ErrorMessage, useField, defineRule, configure } from 'vee-validate';
import { localize, setLocale } from '@vee-validate/i18n';
import { required, email } from '@vee-validate/rules';

var script$b = defineComponent({
    name: 'ScoutsDummyBar'
});

const _hoisted_1$a = {
  class: "header",
  role: "banner"
};
const _hoisted_2$9 = { class: "header__inner" };
const _hoisted_3$5 = { class: "header__logo" };
const _hoisted_4$5 = /*#__PURE__*/createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30.7 46.8"
}, [
  /*#__PURE__*/createElementVNode("path", { d: "M22 28.6l-.2.2c-.2 0-.3 0-.3-.1v-.2c0-.1.1-.2.1-.2h.2c.1 0 .1 0 .2.1v.1c-.1 0 0 .1 0 .1zm7.1 5.5c.1-.1.1-.2.3-.3v-2h-2.6c.1-.1.2-.1.2-.1.9-.7 1-1.5 1.1-2.6l.3-4.1c.1-1 .1-2-.8-2.8-.7-.6-1.7-.7-2.6-.8.1.2.2.5.2.7 0 .4 0 .8-.1 1.2l.3.2.2.5s-.1-.1-.2 0v.3l.1.1h-.2v.2l-.1-.1h-.1c0 .1.1.1.1.2s0 .1.1.2c.1.3.2.6.2.9v1c0 .3-.2.7-.4 1l-.1.1-.1 1.1c-.1.8-.3 1-1 1h-.3l.1-1.4c-.3.1-.6.1-.8 0-.5-.1-1-.2-1.4-.6-.4-.3-.7-.7-.9-1.1 0 .1-.1.1-.1.1l-.2 2.2c0 .4-.1.7-.5.8l-.1 1.9h.2c.1 0 .1.1.2.1v-.1l.6.1v.4c.2.1.5.3.7.4 1.2.6 2.6 1 3.9 1.2l-.6-1.6H26s.1 0 .2-.1v1.5l.3.3c.5 0 .7.1 1.2.1l-.2.2c-.4 0-.5 0-.9-.1v1.9l1.9-1.8-1 3.8h.1l1-3.8.8 2.5-1.5 1.5 1.5-1.3v-2.8c-.8 0-.7-.1-.3-.2zM18.5 6.7l.1-.3h-.3l-.1.1c-.1 0-.2 0-.3.1-.1 0-.2 0-.3-.1 0 0 0-.1-.1-.2h-1.4v1.1c0 .4.1 1.1-.6 1.1v.2c.3.1.6.1.9.2.3.1.7.2 1 .3l.6.3.6.3.1.1c.1-.1.2-.1.3-.2V7.6h-.3v-.1s.1-.1.2-.1h.1v-.5c-.1.1-.2.1-.4.1.1 0 0-.1-.1-.3zm.7 3.7l-1.6.1.9-.3c-.4-.1-.8-.3-1.2-.3-.6-.1-1.2-.2-1.7-.3 0 .3-.1.5-.1.8v.2h-.2c0-.1.1-.2.1-.4v-.6c-.9 0-1.9.1-2.8.3v.1c.5.5 1.4.7 2.4.8l.1 3.1h.1l.2-.6.3-.5-.3.6v.2l-.4.6v.4c.1 0 .1 0 .2-.1l.3-.3-.3.5v.3l2.1-.1-.1-1.6c0-.4.1-.7.5-.7l.1 2.1c.3-.4.5-.8.7-1.3.4-1 .7-1.9.7-3zM8.6 24.5c-.1 0-.1 0 0 0v-.2c-.1 0-.3.1-.5.1-.3 0-.4.2-.4.4l.3.1c0-.2 0-.3.2-.2h.3c-.7 1.1-1.1 2.3-1.4 3.6h-.2c-.1 0-.2.1-.2.2-.1.1-.2.1-.3.2h-.1v.1c.3-.1.5 0 .6 0v.1l-.1.1-.2.2.3.1c0 .1 0 .3-.1.4v.5c.1.2.2.3.4.4.3.3.7.5 1 .6.2-.8.6-1.6 1.1-2.3.1-.1.2-.3.4-.4v-.1l.3-4.9c0-.3.1-.6.2-.8-.2.1-.3.2-.5.4l-.7.7c-.1.2-.2.5-.4.7zm-.4-.7c-.1 0-.2.1-.3.2-.1.1-.2.1-.3.1l.1.1h.4s.1-.1.2-.1l.1-.1v-.1l-.2-.1zm-.2-.1l.1-.2h-.3s-.1.1-.1.2c0 0 .1 0 .2.1 0-.2.1-.2.1-.1zm-1 2.4s-.1.1-.2.1h-.3v.2H7l.3-.2-.1-.2c-.1 0-.2 0-.2.1zm-.3-1.5c.1 0 .2 0 .3-.2l-.1-.1-.3.2h-.1v.2c.1 0 .1 0 .2-.1zm-.6 7.6l.2.2-.4-.4h-.2c-.1.1-.1.1-.2.1h-.3l-.3-.2c-.1 0-.1 0-.2.1v.1s-.1.1-.1 0c-.1 0-.1 0-.1.1s0 .1.1.2c.1 0 .1.1.2.1l-.2-.3c-.1 0-.1 0-.1.1s0 .1.1.1h-.1c.7.8 1.4 1.4 2.2 1.8.1-.1.2-.1.4-.1.4 0 .5.2.6.5.5.1 1.1.2 1.6.2l-.1.1c-.3 0-.6 0-.9-.1-.2 0-.4-.1-.6-.2 0 .2.1.4.1.6v.2h3.3v-.8H11c-.2.1-.5.1-.7.1s-.5.1-.7.1c0 0 .1 0 .1-.1.5 0 1-.1 1.5-.2v-1.7c-.3-.2-.6-.4-1-.5 0 .1 0 .1.1.1h-.1s-.1.1 0 .1c0 .1 0 .1.1.1H10l-.1.1s0 .1.1.1c-.1-.1-.2-.1-.2-.1h-.2s-.1 0-.1-.1h-.2c0-.1 0-.1-.1-.1s-.1 0-.2-.1v-.1s-.1 0-.1-.1l-.1-.2v-.2c-.2 0-.3-.1-.5-.1h-.2c-.1 0-.1.1.1.2-.1 0-.1 0-.1-.1 0 0 0-.1-.1-.1-.2-.1-.4-.1-.6 0s-.4.1-.6 0l-.1.1c0 .1 0 .1-.1.2l.4.2.3.2-.4-.2h-.1l-.6-.4c-.2.1-.2.2-.1.4zm-2.1.2c0 .1 0 .1 0 0-.1.1-.1.1 0 0-.1.1-.2.1-.2.1-.1.4-.2.9-.1 1.3.1.5.3 1 .6 1.4.5.7 1.1 1.3 1.9 1.6s1.6.4 2.5.4c.2 0 .4-.1.5-.1.2 0 .3-.1.5-.1v.1c.1 0 .2.1.3.1.1.1.2.1.3-.1l-.1-.2c-.1.1-.1.1-.2.1h-.1c0-.1-.1-.1-.1-.1.1 0 .2-.1.3-.1-.7-.4-1.8-.7-2.6-1-.3-.1-.8-.2-1-.4s-.2-.4-.2-.6.1-.4.2-.6c-.4-.2-.9-.5-1.2-.8-.4-.3-.7-.7-1.1-1.1l-.2.1c0-.1 0-.1 0 0 .1 0 .1.1 0 0 .1 0 .1 0 0 0zm-.4 1.4v-1.1c-.5.5-.7 1.1-.7 2.1v.2c0 2.4 1.2 2.9 3.3 3.5 1 .2 1.7.3 1.7 1.5 0 .4-.2.9-.7.9-.3 0-.5-.1-.6-.4-.1-.2-.1-.7-.1-1.4H3.1v3c1.1.9 2.6 1.2 4.1 1.2 3.3 0 4.3-1.6 4.3-3.8v-.1c0-.5-.1-1.1-.3-1.5 0-.1-.1-.2-.2-.3h-.2c-.1 0-.1-.1-.2 0v.1h.2l.1.1-.6.1-.1-.1h-.1v.1h-.4c-1.1 0-2.1-.3-3.1-.7s-1.9-1.1-2.5-2.1c-.2-.4-.4-.8-.5-1.3zm6.1 3.6c.2.1.2.1.3.1s.1 0 .2.1v-.1c-.1-.1-.1-.1-.2-.1h-.1c-.1-.1-.2-.1-.2 0zm.1.2c-.1.1 0 .1 0 0 0 .1 0 .1.1.2 0 0 .1 0 .1-.1 0 0 0-.1-.1-.1-.1.1-.1 0-.1 0zM6.4 26.8v.3c.1 0 .1-.1.2-.1.1-.1.4-.1.5-.1v-.2l-.1-.1c-.2.1-.3.2-.4.2h-.2zm.2 1.1c-.1.1-.2.1-.3.2v.2c.2 0 .3 0 .5-.1 0 0 .1-.1.2-.1.1-.1.1-.1.1-.2v-.1h-.2c-.1.1-.2.1-.3.1zm.5-2.4v.1h.1l.1-.1v-.1l-.2.1c.1 0 .1 0 0 0zm5.2 5.3h.2-.2zm-1.9-1.6c-.4 0-.6-.3-.6-.5l-.4.4c-.5.7-.8 1.4-1 2.1.5.2 1.1.3 1.7.3.9.1 2 0 2.9-.3v-.1c-.1-.1-.1-.1-.2-.1l.1-.1v-.1h-.1l.3-.3v-.1s-.1-.1-.2-.1c.2 0 .3 0 .4-.1 0 0 .1-.1 0-.1V30h.3l.2-.2c.1.1.1.1.3.1l.3-4.4c-1.1.4-2.1.9-3.1 1.6v-.2c.4-.3.8-.6 1.3-.8.5-.3 1-.5 1.4-.6.1 0 .2 0 .2-.1l-3.8-.3.2 2.2h.4l.2-.2s0 .1-.1.2v.5c0 .5 0 1.4-.7 1.4zm1.6 5.7v5c0 .4 0 .8-.4 1.1v2H20v-3.6c-.3-.2-.6-.3-.9-.5h-2.3v.4c0 .9 0 1.3-1 1.3h-.2v-2.3h2.2v-.4c-.6-.5-1.2-1.1-1.7-1.8h-.5v-.7c-.1-.2-.3-.4-.4-.6-.6-1-1-2-1.2-3.1h-2.4v2c.4.4.4.8.4 1.2zm7.8 4.1zm-2.3-1.3v-1.4h-1.4c.5.5.9 1 1.4 1.4zm-3.9-16.5c-1.1.3-2.1.8-3 1.4.1 0 .2-.1.3-.1.8.1.6 1 .6 1.5v.2l3.3.2.2-2.8-.9-.6c-.3.1-.4.1-.5.2zm1.1 8.5l-.1 1.9 2.9.2H14v.2c.3 1.1.7 2.2 1.4 3.1v-1h.2c.9 0 1 .3 1 1.1v.3h3.2v-3.4c-.2-.1-.4-.3-.7-.4h-.4l.1-1.9c-.4-.3-.3-.7-.3-1.1l.3-4.9c0-.4 0-.8.4-1l.1-1.9-3.9-.2-.1 1.9c.4.3.3.7.3 1.1l-.3 4.9c-.2.5-.2.9-.6 1.1zm3.4-11.4h-.3c0 .1-.1.1-.2.2l.1 1.7 3.7-.1-.1-1.7c-.4-.2-.3-.6-.4-.9v-.7c-.3.2-.5.5-.9.7-.5.3-1.2.6-1.9.8zm4.5 3.3c-.4-.2-.9-.4-1.4-.5l-1-.1-.1 1.7s.1 0 .1.1h.1c0 .1 0 .1.1.1s.1 0 .1.1v.1l.1.1.1.2v.3l.7-.1c.1 0 .1-.1 0-.1 0 0 .1 0 .1.1v.1c.2.1.4.1.5 0 .2-.1.4 0 .5.1l.1-.1s0-.1.1-.1l-.3-.2-.3-.2.3.2h.1l.5.4s.1-.1 0-.2c0-.1-.1-.1-.1-.2l.3.4h.1l.1-.1h.3l.2.2h.2v-.1h.2c0-.1 0-.1-.1-.1s-.1-.1-.1-.1l.2.1h.1v-.1c-.6-1.1-1.2-1.6-1.8-2zm.5 3c0-.1 0-.1 0 0 0-.1 0-.1-.1-.2h-.1c0 .1-.1.1-.1.2l-.7.3.1-.1h.1v-.1h.1l.2-.1v-.2h-.2l-.8-.1h-.2l-.2.1h-.4c-.1 0-.2 0-.3.1l-.1.9c.5 0 1 0 1.6-.1s1.1-.3 1.7-.6c.1 0 .2-.1.2-.2v-.1h-.1c-.1 0-.1-.1-.2 0h-.2v-.1h-.1c-.1.2-.1.2-.2.3zm.3 1.5c-.1.1-.1.1 0 0-.1 0-.1 0 0 0-.1 0-.1 0 0 0zm-.5 1.3l-.2.1-.1-.2c0-.1.1-.1.2-.1l.1.1v.1zm-.5-.9l-.1.1h-.2s0-.1-.1-.1l.1-.2h.1c.2 0 .2.1.2.2zm-.5 0l-.1.1-.4.1.3-.4h.2v.2zm1.6 1.9l.2-3.4c-.2.2-.5.3-.8.5s-.8.3-1.3.4h-1.3v.4c.1.4.3.7.6 1s.6.6.9.8l.6.3c.2.1.4.1.7.1.2 0 .3 0 .4-.1zm1.4-7l-3.3-.3c.1 0 .3.1.4.1l.6.3c.4.2.7.5 1 .7.3.3.6.6.8 1h.2s0-.1 0 0h.1c.2-.4.2-.8.2-1.2.2-.2.1-.4 0-.6zm.1 3.2v.8h-.1l-.1 2.3.2-.2c.2-.5.3-1 .3-1.6 0-.5-.1-.9-.3-1.3zm1.4-8l-3 .1v1.2h.1c.1 0 .2 0 .3.1l.2-.6.3-.5-.3.6v.2l-.6 1v.1c.1.1.2.1.4-.1l.3-.3-.5.5c0 .1 0 .2.1.3.1.1.1.2.2.3.5.3 1 .5 1.6.6.6-.7 1.1-1.3 1.4-2-.1-.1-.2-.1-.3-.2-.1-.3-.1-.8-.2-1.3zm-2.9 21.7v-.6l-.4-.1c-.1 0-.2 0-.3-.1l-.1.3.1.1-.1.2h-.1v.1l.6.1-.2 1-2.2-.6.2-.9.6.1v-.1h-.1l.1-.2h.1l.1-.3c-.1 0-.2 0-.3-.1l-.3-.1-.2.6h-.2v2c.9.3 1.8.5 2.7.6v-2zm-.2-.8l.4.1-.1.5v.1l.6.2.5-2-.6-.2-.2.6-.4-.1c0 .1-.2.3-.2.3s.1.3 0 .5zm-1.5-2.2l.6.2-.1.4c.2 0 .4.2.4.2s.2-.1.4 0l.1-.4.6.1.2-.6-2-.5-.2.6zm.8 2.7l-.8-.2-.1.3-.6-.2-.2.7 2 .5.2-.6-.6-.1.1-.4zm-.7-.5c.2-.1.2-.3.2-.3s-.1.1-.2.1v.2zm.7-.3s-.1.2.1.4l.1-.3c-.1 0-.2-.1-.2-.1zm-1.8.3l.2-.6.4.1c0-.2.2-.4.2-.4s-.1-.2 0-.4l-.4-.1.2-.6-.6-.2v2.2zm0-2.2l.8.2-.1.6.3.1c.1-.1.4 0 .4 0s-.1-.2.1-.3l.1-.3-.6-.1.2-.9 2.2.6-.2 1-.6-.1-.1.3c.1.1 0 .3 0 .3s.2 0 .3.1l.3.1.1-.6.9.2-.6 2.2-.7-.2.7 1.7.6 1.6.6 1.4h3.4v-3.9l-.4.4-.8-.8-.1.1.2.1-.2.5-.4-.1.5 1.2-.5-.1-.2-.4v.8l-.7.6-.3-.8.3-.7-.3.2-.6-.1 1-.8-.4-.1.1-.6.3.1v-.2l-1.1.3-.5-1.7 1-1-.8-2.1h-.1c-.9-.1-1.6-.3-2.2-.5s-1.2-.4-1.8-.7c-.2-.1-.5-.3-.7-.4v1.2c.4.3.4.7.4 1.1v.5h.2zm8.2 2.9v.2l-.2-.2-.2.1.1-.2-.1-.2.2.1.1-.2v.3-.6l-1.7 1.4v.1h.1l.3-.3.8.8.5-.6v-.2l.1-.5zm-.8-3.2l-.8 3.3h.1l1.4-1.4-.7-1.9zM26 40.1l.6-.5.1-.2-.7.7zm.9-.1l-.3-.1-.4.9.2.6.5-.4v-1zm-1.2-2.6l-.2.1.1-.2-.2-.2.2.1.1-.2v.3l.2.1h-.2v.3-.3zm-.3 1.3l1.1-.3.1.4h.1v-.1l-.9-2.3-.8.8.4 1.5zm1.4-.4l-.6-1.9v.4l.6 1.5zm1-3.3l-1.5 1.4.6 1.9h.1l.8-3.3zm-.5 5.5h.2l-.4-1-.1.3.3.7zm.1 3.3h-.6v3h.7v-1.5l.9 1.5h.6v-3h-.7v1.5l-.9-1.5zm-1.2 0h-2v3h2v-.6h-1.3v-.5H26v-.6h-1.1v-.5h1.3v-.8zm-5.8-.7h3.5v-2l-.1-.1c-1-.3-2-.6-2.9-1 0 .4 0 .8-.4 1.1l-.1 2zm2.2 1.3c.2 0 .3.1.3.3s-.1.3-.3.3h-.4v-.6h.4zm.1-.6h-1.2v3h.7v-1.1h.2l.5 1.1h.8l-.6-1.2c.2-.1.5-.4.5-.8.1-.6-.3-1-.9-1zm-1.7 0h-2v3h2v-.6h-1.3v-.5h1.1v-.6h-1.1v-.5H21v-.8zm-3.7.6c.2 0 .3.1.3.2.1.1.1.2.1.7s0 .6-.1.7c-.1.1-.2.2-.3.2H17v-1.7h.3v-.1zm.1-.6h-1.1v3h1.1c.3 0 .6-.1.8-.3.3-.3.3-.7.3-1.2s0-.8-.3-1.2c-.2-.3-.5-.3-.8-.3zm-3.4 0h-.6v3h.7v-1.5l.9 1.5h.6v-3h-.7v1.5l-.9-1.5zm-2.5 1.9l.3-.8.2.8h-.5zm0-1.9l-1.1 3h.8l.1-.4h.9l.1.4h.8l-1.1-3h-.5zm-2.7 1.9l.3-.8.2.8h-.5zm-.1-1.9l-1.1 3h.8l.1-.4h.9l.2.3h.8l-1.1-3-.6.1zm-2.4 0h-.7v3h2v-.6H6.4l-.1-2.4zm-2.8 0h-.8l1 3h.5l1-3h-.8l-.5 1.7-.4-1.7zm-.9-17.6v.1c.1 0 .1-.1 0-.1zm-.2.7v.1-.1zm-.1-.2v.1h.1l-.1-.1zM3.4 25c.1 0 .1 0 0 0 .1 0 .1 0 0 0zm.4-6.2c-.6 0-.6-.7-.6-.7l-.1-4.4c0-.1-.1-.7.6-.8.6 0 .6.7.6.7l.2 4.4c-.1.1 0 .8-.7.8zm-.2 5c.1.3.3.6.5.9-.1.1-.3.2-.5.3.2-.1.3-.1.5-.3.1.1.2.3.3.4h-.1c-.1.1-.3.2-.5.2-.3 0-.6-.4-.6-.8 0-.3.1-.6.4-.7zm0 2.4c0 .1.1.1.1.1v.1h-.1v-.2zm.6-3.9c-.1-.2-.3-.5-.3-.7s.1-.3.2-.4l.3.4c.1.1.1.2.1.3-.1.2-.2.4-.3.4zm.4-.4c0-.1-.1-.1-.1-.2-.1-.1-.2-.3-.3-.4l.1-.1c.2 0 .3.2.3.4v.3zm0 1.4c.1-.1.1-.2.2-.3h.1v-.1c.3-.4.5-.8.5-1.2 0-.5-.3-.8-.6-1 .2 0 .8-.1 1-.2.8.8.7 1.7.7 2.2v.2H5.3v.5h.2c.1 0 .2.1.2.3 0 .1 0 .3-.2.4l-.2.2c-.1-.2-.3-.5-.4-.7v-.5c0 .1-.1.3-.1.4l-.2-.2zm1.1 1.3s0-.1 0 0c0-.1 0 0 0 0zm.2-.1c.1 0 .1 0 .1.1s0 .1.1.2c0 .1 0 .1.1.2h-.1c-.1-.1-.1-.1-.1-.2-.1-.2-.1-.2-.1-.3zm.2.1v-.1c-.1 0-.1 0-.1-.1v-.1s0-.1-.1-.1v-.1H6v.1l.1.1v.1l.1.1-.1.1c.1.1.1 0 0 0zm.1.1c.1 0 .1 0 0 0 .1 0 .1.1 0 0zm.1-.3c-.1-.1-.1-.1 0 0-.1-.1-.1-.1 0 0l-.1-.1v-.1l-.1-.1L6 24v-.1h.1v.2s0 .1.1.1c0 0 0 .1.1.2 0-.1 0-.1 0 0zm0-.6zm0-.3s.1 0 .1-.1l-.1.1zm.1.6s-.1-.1 0 0l-.1-.1h.1v.1c0-.1 0 0 0 0zm.1-.2c0-.1.1-.1 0 0 .1 0 .1 0 0 0l.1.1-.1-.1c0 .1 0 0 0 0zm.1-.5v-.1.1zM4.4 10.8h-.9c-2.1.1-3.6.7-3.5 3.1L.1 18c.1 2.4 1.1 2.9 3.1 2.9-.2.2-.3.5-.3.9s.1.7.2 1.1c-.5.3-1.1.8-1.1 1.7 0 .7.3 1.4 1.1 1.6-.2.2-.3.4-.4.7-.1.1-.1.3-.1.6 0 .2.1.4.1.5.1.2.2.4.3.5.1.2.3.3.5.4s.4.2.7.2c.4 0 .8 0 1.2-.2.3-.2.6-.5.7-.8.1-.2.1-.3.1-.5s-.1-.3-.2-.5l-.3-.3c-.1 0-.2-.1-.4-.1h-.1v.1c.1 0 .2.1.3.1.1 0 .2.1.3.1.2.1.3.3.4.5 0 .2 0 .4-.1.6-.1.3-.4.5-.7.6-.3.2-.7.3-1 .2-.3 0-.6-.1-.8-.3-.2-.2-.4-.4-.5-.6s-.1-.4 0-.6c0-.2.1-.3.2-.5s.2-.3.4-.4c.1-.1.2-.2.3-.2l-.1-.1v-.1H4v.4l.1-.1-.1-.2h.1c0 .1.1.1.1.2.1 0 .1-.1.1-.1.1 0 .1-.1.2-.1v-.1h.1v.1l.1-.1h.1v.1H5v-.1h.2c.3.3.7.4 1 .4s.6-.1.7-.4c0 0 .1-.1.2-.1l.1-.1c0-.1-.1-.1-.2-.1 0-.1.1-.2.1-.4v-.3h-.6v.3c0 .2-.1.3-.3.3-.1 0-.3-.2-.4-.4v-.1l.1.1c0 .1.1.1.1.2h.1v-.2l-.1-.1s0-.1-.1-.1V25s-.1 0-.1-.1v-.1c.1 0 .1.1.1.1v.2l.1.1.1.1.4-.4c.1-.1.2-.2.2-.3l.5-.5h.2l.1-.1-.1-.1.2-.2.2-.2c1.5-1.1 3.2-1.8 5-2.2.2-.1.5-.1.8-.1-.3-.2-.7-.3-1-.4.4-.1.8-.2 1.2-.4-1.3-.1-2.5-.4-3.7-.9-.7-.3-1.4-.6-2-1.1.1.7.3 1.3 1 1.8.1.1.3.1.5.2-.6.1-1.2.2-1.7.6-.6.4-.9 1.1-1 1.7-.1-.3-.1-1.4-.8-2 1-.4 1.6-1.2 1.5-2.8v-.5c-.4-.4-.8-.8-1.1-1.3-.4-.6-.7-1.3-.9-2-.2-.7-.2-1.5 0-2.2l-.5-.2-.7-.9zm6.4 2.6c0-.4-.1-.7.3-1l-.1-1.7H9.6s0 .1-.1.1c0 .1 0 .2-.1.3l.6.2.6.4-.6-.3h-.2l-1-.6c-.1 0-.1.2.1.4l.3.3-.7-.6c-.1 0-.2 0-.3.1s-.2.1-.3.2h-.2l-.3.1-.1-.1.1 1.4c.2.1.3.3.3.5.7.6 1.5 1.1 2.2 1.4l.9.3v-1.4zM6 11.8c0 .1 0 .1 0 0h-.3c-.2.7-.3 1.5 0 2.3.2.8.5 1.5 1 2.1.2.3.5.6.7.8l-.1-3.3c0-.8-.2-1.4-.6-1.9l-.1-.1h-.5c0 .1 0 .1-.1.1.1 0 .1 0 0 0zm-.4-2.5V7.4c0-.2.1-.5.1-.7H4v2.7c.5.4 1.2.7 1.8.9 0-.4-.1-.7-.2-1zm5.8-5.8V1.1C10.3.3 9.1 0 7.7 0c-.9 0-1.9.1-2.6.6-.8.6-1 1.2-1.1 2.2V3c0 1.8.7 2.5 2.1 2.9.1-.1.1-.3.2-.4.4-.6.9-1.1 1.5-1.4l.6-.3h-.1c-.3-.1-.7-.2-.9-.4-.2-.2-.2-.4-.2-.6 0-.4.2-.7.6-.7.6 0 .6.6.6 1.1v.2l3 .1zm-.6 2.6c0 .1-.2.2-.4.2 0 0-.1 0-.1-.1v-.4l.1-.1h.1l.3.4zM9.6 8.4l-.1.1c-.1 0-.1 0-.1-.1.1-.1.1-.1.2 0 0-.1 0-.1 0 0zM7.2 9c0 .1-.1.1-.2.1h-.1L6.8 9v-.1s.1-.1.3-.1c0 0 .1 0 .1.2zm-.4.3l.2.2c0 .2-.4.4-.5.4s-.3 0-.5-.1v-.1c.1 0 .5-.2.6-.3-.1 0 0-.1.2-.1zm4.8-2.1c0-.5-.1-1-.2-1.4-.1-.4-.4-.7-.8-1-.5-.4-1.3-.6-2-.8-.4.1-.8.2-1.1.4-.6.4-1.1.9-1.4 1.6.2.1.5.2.8.2.9.2 1.5.3 1.5 1.4 0 .4-.2.8-.6.8-.2 0-.5-.1-.6-.3s-.1-.7-.1-1.3H5.8c-.2.7-.3 1.5-.1 2.4.1.4.1.8.3 1.2.6.1 1.1.2 1.7.2.4 0 .8 0 1.1-.1.5-.4.9-.7 1.4-.9l.9-.3c.2-.3.3-.7.4-1.2-.2 0-.3-.2-.3-.5l.2-.2h.1c.1-.1.1-.1.1-.2zm.3 3.6c-.1 0-.1 0-.2-.1h-.1l.1 1.7c.4.2.4.6.4.9l.1 1.7c.7.1 1.4.2 2.1.1l-.1.1c-.5 0-1 0-1.5-.1-.2 0-.4-.1-.5-.1l.1 2.6c0 .2 0 .7-.6.7s-.6-.5-.6-.7l-.1-3-.9-.3c-.7-.3-1.5-.7-2-1.2-.1 0-.1-.1-.2-.1v.3l.1 3.9v.5c.5.3.9.6 1.5.8 1.3.4 2.6.6 4 .5.3-.1.6-.1.9-.2.1 0 .3-.1.5-.1.2-.5.2-1 .2-1.6l-.1-1.9h-.4s.1 0 .1-.1c.1 0 .2 0 .3-.1l-.1-1.9c0-.4 0-.8.2-.9v-.7h-.2l-.1.1s0 .1.1.2c-.1-.1-.3-.2-.4-.2h-.2s-.1 0-.2-.1l-.3.1c0-.1 0-.2-.2-.2-.1 0-.2 0-.3-.1v-.1s-.1 0-.1-.1l-.1-.3v-.3h-1.2c-.1.2-.1.3 0 .3zm1.2-3.6l-.5.8-.4-.1-.3-.4v-.1s.1-.1.1-.2l.8-.3h.1c.1.2.1.2.2.3zm.6-1.2c-.5-.5-1.1-1-1.8-1.3v2.2c0 .7 0 1.4.2 2 .2 0 .3-.1.5-.1 1-.1 1.9-.1 2.8 0 0-.1 0-.2-.1-.3s-.2-.3-.2-.5v-.1c-.4-.7-.8-1.4-1.4-1.9zm5.6-1.8V1.4C18.3.7 17 .3 15.8.2s-2.3.2-3 .7-.8 1.3-.9 2.1c.3 0 .5 0 .6.2 0 .1.1.3 0 .4 0 .2-.1.3-.2.4h-.5c.3.1.7.3 1 .5.8.6 1.5 1.2 2 2.1 0-.1.1-.1.1-.2l.1-3.1c0-.4-.1-1.1.6-1.1s.6.7.6 1.1v.6l3.1.3zm3.5 9.7c.4-1.2.6-2.4.5-3.6l-3.9.1v.3c-.1.6-.2 1-.3 1.4s-.2.8-.4 1.2c-.2.5-.5 1-.8 1.5l.1 2.7c0 .2 0 .5-.1.7.1 0 .2 0 .3-.1.8-.2 1.5-.5 2.1-1 .2-.2.4-.3.6-.5l-.1-4.1c.4 0 .5.2.6.7l.1 1.6h1c0-.4.2-.6.3-.9zm1.7-2zm3.5 1.4l2.3-.1-.1-2.3c-.9-.6-1.8-.8-2.8-.9.1.2.2.3.2.5l.3 1.2c.1.4.1.8.1 1.2 0 0 0-.1-.1-.1-.1-.8-.2-1.6-.5-2.4 0-.2-.1-.3-.2-.4h-.7c-.9 0-1.8.2-2.5.7-.3.2-.4.4-.6.6 0 .1.1.3.2.3v.2s-.1.1-.1.2c-.1.2-.1.4-.1.6-.1.2-.1.4-.2.6-.2.5-.4.9-.6 1.3h.9v-.1l-.1-.1h.1v.1c.4.9 1.3 1.2 2.7 1.5.5.1 1 .2 1.3.5.3-.9.4-1.8.4-2.7-.2 0-.4-.1-.5-.1-.3-.1-.7-.2-.9-.4s-.2-.3-.2-.5c0-.4.2-.7.6-.7.6 0 .6.6.6 1v.2l.5.1c-.1-.2-.1-.2-.1-.3l.1.3zm2.7 3.5c0-.5-.1-1-.3-1.4s-.4-.7-.8-.9c-.5-.3-1.1-.5-1.7-.6v.9c-.1.6-.2 1-.3 1.4 0 .1-.1.3-.1.4.1.2.2.4.2.7 0 .4-.2.8-.6.8h-.2c-.3.5-.6 1-.9 1.4-.2.2-.3.4-.5.6.5.1 1.1.1 1.6.1 2.9-.1 3.7-1.6 3.6-3.4z" })
], -1 /* HOISTED */);

function render$b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = resolveComponent("router-link");

  return (openBlock(), createElementBlock("div", null, [
    createElementVNode("header", _hoisted_1$a, [
      createElementVNode("div", _hoisted_2$9, [
        createElementVNode("div", _hoisted_3$5, [
          createVNode(_component_router_link, {
            to: '',
            class: "cursor-pointer header__logo__inner"
          }, {
            default: withCtx(() => [
              _hoisted_4$5
            ]),
            _: 1 /* STABLE */
          })
        ])
      ])
    ])
  ]))
}

script$b.render = render$b;
script$b.__file = "src/components/ScoutsDummyBar/ScoutsDummyBar.vue";

var script$a = defineComponent({
    name: 'BackButton',
    props: {
        isLoading: {
            type: Boolean,
            required: true,
            default: false
        },
        size: {
            type: String,
            required: false,
            default: '5'
        },
        color: {
            type: String,
            required: false,
            default: 'white'
        }
    }
});

const _hoisted_1$9 = /*#__PURE__*/createElementVNode("path", { d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" }, null, -1 /* HOISTED */);
const _hoisted_2$8 = [
  _hoisted_1$9
];

function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return withDirectives((openBlock(), createElementBlock("svg", {
    class: normalizeClass(["fill-current animate-spin inline-block", 'w-' + _ctx.size + (' h-' + _ctx.size) + (' text-' + _ctx.color)]),
    viewBox: "0 0 24 24"
  }, _hoisted_2$8, 2 /* CLASS */)), [
    [vShow, _ctx.isLoading]
  ])
}

script$a.render = render$a;
script$a.__file = "src/components/loader/Loader.vue";

var script$9 = defineComponent({
    name: 'CustomButtonSmall',
    components: {
        loader: script$a
    },
    props: {
        text: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        type: {
            type: String,
            default: 'submit',
            required: false
        },
        isSubmitting: {
            type: Boolean,
            default: false,
            required: false
        },
        hoverColor: {
            type: String,
            required: false,
            default: 'green'
        },
        extraStyle: {
            type: String,
            required: false,
            default: ''
        }
    }
});

const _hoisted_1$8 = ["disabled", "type"];
const _hoisted_2$7 = { class: "absolute flex justify-center items-center w-full left-0 top-0 h-full" };

function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loader = resolveComponent("loader");

  return (openBlock(), createElementBlock("button", {
    disabled: _ctx.disabled || _ctx.isSubmitting,
    class: normalizeClass(["bg-black uppercase buttonSmall font-black", {
      ' animate-pulse2 loading': _ctx.isSubmitting
    }]),
    type: _ctx.type
  }, [
    createElementVNode("a", {
      class: normalizeClass(["mt-0 relative text-white", _ctx.extraStyle])
    }, [
      createElementVNode("span", {
        class: normalizeClass({ 'opacity-0': _ctx.isSubmitting })
      }, toDisplayString(_ctx.text), 3 /* TEXT, CLASS */),
      renderSlot(_ctx.$slots, "icon"),
      withDirectives(createElementVNode("div", _hoisted_2$7, [
        createVNode(_component_loader, {
          size: "5",
          "is-loading": _ctx.isSubmitting
        }, null, 8 /* PROPS */, ["is-loading"])
      ], 512 /* NEED_PATCH */), [
        [vShow, _ctx.isSubmitting]
      ])
    ], 2 /* CLASS */)
  ], 10 /* CLASS, PROPS */, _hoisted_1$8))
}

script$9.render = render$9;
script$9.__scopeId = "data-v-3b2f25b9";
script$9.__file = "src/components/customButtonSmall/CustomButtonSmall.vue";

var script$8 = defineComponent({
    name: 'CustomButtonSmall',
    components: {
        loader: script$a
    },
    props: {
        text: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        type: {
            type: String,
            default: 'submit',
            required: false
        },
        isSubmitting: {
            type: Boolean,
            default: false,
            required: false
        },
        hoverColor: {
            type: String,
            required: false,
            default: 'green'
        },
        extraStyle: {
            type: String,
            required: false,
            default: ''
        }
    }
});

const _hoisted_1$7 = ["disabled", "type"];
const _hoisted_2$6 = { class: "absolute flex justify-center items-center w-full left-0 top-0 h-full" };

function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loader = resolveComponent("loader");

  return (openBlock(), createElementBlock("button", {
    disabled: _ctx.disabled || _ctx.isSubmitting,
    class: normalizeClass(["btn-simple-dark", {
      ' animate-pulse2 loading': _ctx.isSubmitting
    }]),
    type: _ctx.type
  }, [
    createElementVNode("a", {
      class: normalizeClass(["btn-simple-dark mt-0 relative", _ctx.extraStyle])
    }, [
      createElementVNode("span", {
        class: normalizeClass({ 'opacity-0': _ctx.isSubmitting })
      }, toDisplayString(_ctx.text), 3 /* TEXT, CLASS */),
      renderSlot(_ctx.$slots, "icon"),
      withDirectives(createElementVNode("div", _hoisted_2$6, [
        createVNode(_component_loader, {
          size: "5",
          "is-loading": _ctx.isSubmitting
        }, null, 8 /* PROPS */, ["is-loading"])
      ], 512 /* NEED_PATCH */), [
        [vShow, _ctx.isSubmitting]
      ])
    ], 2 /* CLASS */)
  ], 10 /* CLASS, PROPS */, _hoisted_1$7))
}

script$8.render = render$8;
script$8.__scopeId = "data-v-56556b4f";
script$8.__file = "src/components/customButton/CustomButton.vue";

var script$7 = defineComponent({
    name: 'CustomHeadline3',
    props: {
        text: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    }
});

const _hoisted_1$6 = {
  key: 0,
  class: "font-semibold text-xl leading-9 pt-3 pb-3"
};
const _hoisted_2$5 = {
  key: 1,
  class: "text-lg font-extrabold leading-5 pt-4 pb-1"
};

function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", null, [
    (_ctx.type === 'h2')
      ? (openBlock(), createElementBlock("h2", _hoisted_1$6, toDisplayString(_ctx.text), 1 /* TEXT */))
      : createCommentVNode("v-if", true),
    (_ctx.type === 'h3')
      ? (openBlock(), createElementBlock("h3", _hoisted_2$5, toDisplayString(_ctx.text), 1 /* TEXT */))
      : createCommentVNode("v-if", true)
  ]))
}

script$7.render = render$7;
script$7.__file = "src/components/customHeader/CustomHeader.vue";

var script$6 = defineComponent({
    name: 'BaseSideBar',
    props: {
        title: {
            type: String,
            required: true
        },
        isDisplay: Boolean,
        selection: {
            type: String,
            required: false,
            default: ''
        },
        options: {
            type: Array,
            required: false
        },
        width: {
            type: String,
            default: 'max-w-md',
            required: false
        },
        isEdit: Boolean,
        name: String,
        isOverflowHidden: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    setup: function (props, context) {
        var selected = ref(props.selection);
        var _a = toRefs(props), isDisplay = _a.isDisplay, selection = _a.selection;
        var hideSideBar = function () {
            context.emit('update:isDisplay', false);
            context.emit('hideSidebar');
        };
        var emitOption = function () {
            context.emit('options', selected.value);
        };
        watch(selection, function (value) {
            selected.value = value;
        });
        watch(isDisplay, function (value) {
            if (props.isOverflowHidden === true) {
                if (value == true) {
                    document.body.classList.add('overflow-hidden');
                }
                else {
                    document.body.classList.remove('overflow-hidden');
                }
            }
        });
        return {
            hideSideBar: hideSideBar,
            emitOption: emitOption,
            selected: selected
        };
    }
});

const _withScopeId = n => (pushScopeId("data-v-c69e8e72"),n=n(),popScopeId(),n);
const _hoisted_1$5 = { class: "px-4 pb-2 pt-3 custom-background" };
const _hoisted_2$4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x-lg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/createElementVNode("path", { d: "M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" })
], -1 /* HOISTED */));
const _hoisted_3$4 = [
  _hoisted_2$4
];
const _hoisted_4$4 = {
  class: "group-search__title mb-3 mt-0 inline-block relative text-xl my-background",
  style: {"font-size":"2rem","position":"initial","transition":"none !important"}
};
const _hoisted_5$4 = { class: "animate-none" };
const _hoisted_6$3 = {
  key: 0,
  action: ""
};
const _hoisted_7$3 = { class: "flex gap-7" };
const _hoisted_8$3 = ["id", "name", "value"];
const _hoisted_9$3 = ["for"];

function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", null, [
    (_ctx.isDisplay)
      ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "h-full w-full fixed top-0 left-0 overflow-x-hidden bg-black bg-opacity-20 z-40",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.hideSideBar()))
        }))
      : createCommentVNode("v-if", true),
    createElementVNode("div", {
      class: normalizeClass([{ 'd-flex': _ctx.isDisplay, 'd-none': !_ctx.isDisplay, 'max-w-md': _ctx.width === 'max-w-md', 'max-w-2xl': _ctx.width === 'max-w-2xl', 'max-w-xl': _ctx.width === 'max-w-xl'  }, "bg-white fixed flex-col top-0 right-0 h-full z-50 xs:w-11/12 sm:w-11/12 md:w-100"])
    }, [
      createElementVNode("div", _hoisted_1$5, [
        createElementVNode("div", {
          class: "mb-4 cursor-pointer",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.hideSideBar()))
        }, _hoisted_3$4),
        createElementVNode("h1", _hoisted_4$4, [
          createElementVNode("span", _hoisted_5$4, toDisplayString(_ctx.title), 1 /* TEXT */)
        ]),
        (_ctx.options && !_ctx.isEdit)
          ? (openBlock(), createElementBlock("form", _hoisted_6$3, [
              createElementVNode("div", _hoisted_7$3, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (option) => {
                  return (openBlock(), createElementBlock("div", { key: option }, [
                    withDirectives(createElementVNode("input", {
                      id: option.value + _ctx.name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.selected) = $event)),
                      class: "cursor-pointer",
                      type: "radio",
                      name: option.value + _ctx.name,
                      value: option.value + _ctx.name,
                      onChange: _cache[3] || (_cache[3] = $event => (_ctx.emitOption()))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_8$3), [
                      [vModelRadio, _ctx.selected]
                    ]),
                    createElementVNode("label", {
                      for: option.value + _ctx.name,
                      class: "ml-2"
                    }, toDisplayString(option.text), 9 /* TEXT, PROPS */, _hoisted_9$3)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : createCommentVNode("v-if", true)
      ]),
      renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */)
  ]))
}

script$6.render = render$6;
script$6.__scopeId = "data-v-c69e8e72";
script$6.__file = "src/components/baseSideBar/BaseSideBar.vue";

var script$5 = defineComponent({
    name: 'SuccessToast',
    props: {
        label: {
            type: String,
            required: false,
            default: 'Succesvol toegevoegd'
        }
    },
    emits: ['hideToast'],
    setup: function (props, _a) {
        var emit = _a.emit;
        var hideToast = function () {
            emit('hideToast', false);
        };
        return {
            hideToast: hideToast
        };
    }
});

const _hoisted_1$4 = {
  role: "alert",
  "aria-label": "Statusbericht",
  class: "alert alert-dismissible alert-status-msg fadeIn show container alert-success"
};
const _hoisted_2$3 = /*#__PURE__*/createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 587.9 587.9\"><path d=\"M471.5 116.4C424.1 69 361 42.8 294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.2-73.6-177.6zM294 544.6C155.5 544.6 43.3 432.4 43.3 294 43.3 155.5 155.5 43.3 294 43.3c138.4 0 250.6 112.2 250.6 250.6 0 138.5-112.2 250.7-250.6 250.7zm177.5-428.2C424.1 69 361 42.8 294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.2-73.6-177.6zM294 544.6C155.5 544.6 43.3 432.4 43.3 294 43.3 155.5 155.5 43.3 294 43.3c138.4 0 250.6 112.2 250.6 250.6 0 138.5-112.2 250.7-250.6 250.7zm177.5-428.2C424.1 69 361 42.8 294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.2-73.6-177.6zM294 544.6C155.5 544.6 43.3 432.4 43.3 294 43.3 155.5 155.5 43.3 294 43.3c138.4 0 250.6 112.2 250.6 250.6 0 138.5-112.2 250.7-250.6 250.7zm177.5-428.2C424.1 69 361 42.8 294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.2-73.6-177.6zM294 544.6C155.5 544.6 43.3 432.4 43.3 294 43.3 155.5 155.5 43.3 294 43.3c138.4 0 250.6 112.2 250.6 250.6 0 138.5-112.2 250.7-250.6 250.7zm270.3-364.9c-14.8-34.9-35.9-66.3-62.9-93.3s-58.3-48.1-93.3-62.9C372 8.3 333.5.5 294 .5c-39.6 0-78 7.8-114.2 23.1-34.9 14.8-66.3 35.9-93.3 62.9-26.9 26.9-48.1 58.3-62.9 93.3C8.3 215.9.5 254.4.5 294c0 39.6 7.8 78 23.1 114.2 14.8 35 35.9 66.3 62.9 93.3s58.3 48.1 93.3 62.9c36.2 15.3 74.6 23.1 114.2 23.1 39.6 0 78-7.8 114.2-23.1 35-14.8 66.3-35.9 93.3-62.9s48.1-58.3 62.9-93.3c15.3-36.2 23.1-74.6 23.1-114.2-.1-39.6-7.8-78.1-23.2-114.3zm-.4 228.3c-14.8 34.9-35.9 66.2-62.8 93.1-26.9 26.9-58.2 48-93.1 62.8-36.1 15.3-74.5 23-114 23s-77.9-7.8-114.1-23c-34.9-14.8-66.2-35.9-93.1-62.8-26.9-26.9-48-58.2-62.8-93.1C8.8 371.8 1 333.5 1 294s7.8-77.9 23-114.1c14.8-34.9 35.9-66.2 62.8-93.1 26.9-26.9 58.2-48 93.1-62.8C216.1 8.8 254.4 1 294 1c39.5 0 77.9 7.8 114 23 34.9 14.8 66.2 35.9 93.1 62.8 26.9 26.9 48 58.2 62.8 93.1 15.3 36.2 23 74.5 23 114.1 0 39.5-7.7 77.8-23 114zM294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.1-73.5-177.6S361 42.8 294 42.8zm0 501.8C155.5 544.6 43.3 432.4 43.3 294 43.3 155.5 155.5 43.3 294 43.3c138.4 0 250.6 112.2 250.6 250.6 0 138.5-112.2 250.7-250.6 250.7zm177.5-428.2C424.1 69 361 42.8 294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.2-73.6-177.6zM294 544.6C155.5 544.6 43.3 432.4 43.3 294 43.3 155.5 155.5 43.3 294 43.3c138.4 0 250.6 112.2 250.6 250.6 0 138.5-112.2 250.7-250.6 250.7zm177.5-428.2C424.1 69 361 42.8 294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.2-73.6-177.6zM294 544.6C155.5 544.6 43.3 432.4 43.3 294 43.3 155.5 155.5 43.3 294 43.3c138.4 0 250.6 112.2 250.6 250.6 0 138.5-112.2 250.7-250.6 250.7z\"></path><path d=\"M471.5 116.4C424.1 69 361 42.8 294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.2-73.6-177.6zM294 544.1c-66.8 0-129.6-26-176.9-73.3-47.2-47.2-73.3-110-73.3-176.8 0-66.8 26-129.6 73.3-176.9C164.3 69.9 227.2 43.8 294 43.8c66.8 0 129.6 26 176.9 73.3 47.2 47.2 73.3 110.1 73.3 176.9 0 66.8-26 129.6-73.3 176.8S360.8 544.1 294 544.1zm177.5-427.7C424.1 69 361 42.8 294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.2-73.6-177.6zM294 544.1c-66.8 0-129.6-26-176.9-73.3-47.2-47.2-73.3-110-73.3-176.8 0-66.8 26-129.6 73.3-176.9C164.3 69.9 227.2 43.8 294 43.8c66.8 0 129.6 26 176.9 73.3 47.2 47.2 73.3 110.1 73.3 176.9 0 66.8-26 129.6-73.3 176.8S360.8 544.1 294 544.1zm177.5-427.7C424.1 69 361 42.8 294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.2-73.6-177.6zM294 544.1c-66.8 0-129.6-26-176.9-73.3-47.2-47.2-73.3-110-73.3-176.8 0-66.8 26-129.6 73.3-176.9C164.3 69.9 227.2 43.8 294 43.8c66.8 0 129.6 26 176.9 73.3 47.2 47.2 73.3 110.1 73.3 176.9 0 66.8-26 129.6-73.3 176.8S360.8 544.1 294 544.1zm177.5-427.7C424.1 69 361 42.8 294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.2-73.6-177.6zM294 544.1c-66.8 0-129.6-26-176.9-73.3-47.2-47.2-73.3-110-73.3-176.8 0-66.8 26-129.6 73.3-176.9C164.3 69.9 227.2 43.8 294 43.8c66.8 0 129.6 26 176.9 73.3 47.2 47.2 73.3 110.1 73.3 176.9 0 66.8-26 129.6-73.3 176.8S360.8 544.1 294 544.1zm270.8-364.6c-14.8-35-36-66.4-63-93.4s-58.4-48.2-93.4-63C372.1 7.8 333.6 0 294 0c-39.7 0-78.2 7.8-114.4 23.1-35 14.8-66.4 36-93.4 63s-48.2 58.4-63 93.4C7.8 215.8 0 254.3 0 294s7.8 78.2 23.1 114.4c14.8 35 36 66.4 63 93.4s58.4 48.2 93.4 63c36.3 15.3 74.8 23.1 114.4 23.1 39.7 0 78.2-7.8 114.4-23.1 35-14.8 66.4-36 93.4-63s48.2-58.4 63-93.4c15.3-36.3 23.1-74.8 23.1-114.4.1-39.7-7.7-78.2-23-114.5zM294 586.9c-39.5 0-77.9-7.8-114.1-23-34.9-14.8-66.2-35.9-93.1-62.8-26.9-26.9-48-58.2-62.8-93.1C8.8 371.8 1 333.5 1 294s7.8-77.9 23-114.1c14.8-34.9 35.9-66.2 62.8-93.1 26.9-26.9 58.2-48 93.1-62.8C216.1 8.8 254.4 1 294 1c39.5 0 77.9 7.8 114 23 34.9 14.8 66.2 35.9 93.1 62.8 26.9 26.9 48 58.2 62.8 93.1 15.3 36.2 23 74.5 23 114.1 0 39.5-7.8 77.9-23 114-14.8 34.9-35.9 66.2-62.8 93.1-26.9 26.9-58.2 48-93.1 62.8-36.1 15.3-74.5 23-114 23zm177.5-470.5C424.1 69 361 42.8 294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.2-73.6-177.6zM294 544.1c-66.8 0-129.6-26-176.9-73.3-47.2-47.2-73.3-110-73.3-176.8 0-66.8 26-129.6 73.3-176.9C164.3 69.9 227.2 43.8 294 43.8c66.8 0 129.6 26 176.9 73.3 47.2 47.2 73.3 110.1 73.3 176.9 0 66.8-26 129.6-73.3 176.8S360.8 544.1 294 544.1zm177.5-427.7C424.1 69 361 42.8 294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.2-73.6-177.6zM294 544.1c-66.8 0-129.6-26-176.9-73.3-47.2-47.2-73.3-110-73.3-176.8 0-66.8 26-129.6 73.3-176.9C164.3 69.9 227.2 43.8 294 43.8c66.8 0 129.6 26 176.9 73.3 47.2 47.2 73.3 110.1 73.3 176.9 0 66.8-26 129.6-73.3 176.8S360.8 544.1 294 544.1zm177.5-427.7C424.1 69 361 42.8 294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.2-73.6-177.6zM294 544.1c-66.8 0-129.6-26-176.9-73.3-47.2-47.2-73.3-110-73.3-176.8 0-66.8 26-129.6 73.3-176.9C164.3 69.9 227.2 43.8 294 43.8c66.8 0 129.6 26 176.9 73.3 47.2 47.2 73.3 110.1 73.3 176.9 0 66.8-26 129.6-73.3 176.8S360.8 544.1 294 544.1zm177.5-427.7C424.1 69 361 42.8 294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.2-73.6-177.6zM294 544.1c-66.8 0-129.6-26-176.9-73.3-47.2-47.2-73.3-110-73.3-176.8 0-66.8 26-129.6 73.3-176.9C164.3 69.9 227.2 43.8 294 43.8c66.8 0 129.6 26 176.9 73.3 47.2 47.2 73.3 110.1 73.3 176.9 0 66.8-26 129.6-73.3 176.8S360.8 544.1 294 544.1zm177.5-427.7C424.1 69 361 42.8 294 42.8c-67.1 0-130.1 26.1-177.6 73.5S42.8 226.9 42.8 294s26.1 130.1 73.5 177.6 110.5 73.5 177.6 73.5S424 519 471.5 471.6 545.1 361 545.1 294c0-67.1-26.1-130.2-73.6-177.6zM294 544.1c-66.8 0-129.6-26-176.9-73.3-47.2-47.2-73.3-110-73.3-176.8 0-66.8 26-129.6 73.3-176.9C164.3 69.9 227.2 43.8 294 43.8c66.8 0 129.6 26 176.9 73.3 47.2 47.2 73.3 110.1 73.3 176.9 0 66.8-26 129.6-73.3 176.8S360.8 544.1 294 544.1z\"></path><path d=\"M563.9 179.9c-14.8-34.9-35.9-66.2-62.8-93.1-26.9-26.9-58.2-48-93.1-62.8C371.9 8.8 333.5 1 294 1s-77.9 7.8-114 23c-35 14.8-66.3 35.9-93.2 62.8-26.9 26.9-48 58.2-62.8 93.1C8.8 216.1 1 254.4 1 294c0 39.5 7.8 77.9 23 114 14.8 34.9 35.9 66.2 62.8 93.1 26.9 26.9 58.2 48 93.1 62.8 36.1 15.3 74.5 23 114.1 23 39.5 0 77.9-7.8 114-23 34.9-14.8 66.2-35.9 93.1-62.8 26.9-26.9 48-58.2 62.8-93.1 15.3-36.2 23-74.5 23-114 0-39.6-7.7-77.9-23-114.1zm-92.4 291.6C424.1 519 361 545.1 294 545.1c-67.1 0-130.1-26.1-177.6-73.5S42.8 361 42.8 294c0-67.1 26.1-130.1 73.5-177.6S226.9 42.8 294 42.8s130.1 26.1 177.6 73.5 73.5 110.5 73.5 177.6-26.1 130.2-73.6 177.6z\"></path><path d=\"M324.2 294l78.8-78.8c8.4-8.4 8.4-21.9 0-30.3-8.4-8.4-21.9-8.4-30.3 0L294 263.7 215.3 185c-8.4-8.4-21.9-8.4-30.3 0-8.4 8.4-8.4 21.9 0 30.3l78.7 78.8-78.7 78.7c-8.4 8.4-8.4 21.9 0 30.3 4.2 4.2 9.7 6.3 15.2 6.3s11-2.1 15.1-6.3l78.7-78.7 78.8 78.7c4.2 4.2 9.7 6.3 15.1 6.3 5.5 0 11-2.1 15.1-6.3 8.4-8.4 8.4-21.9 0-30.3L324.2 294zm78.4 108.6c-4 4-9.2 6.1-14.8 6.1-5.6 0-10.8-2.2-14.8-6.1l-79-79.1-79.1 79.1c-4 4-9.2 6.1-14.8 6.1-5.6 0-10.8-2.2-14.8-6.1-4-4-6.1-9.2-6.1-14.8 0-5.6 2.2-10.8 6.1-14.8l79.1-79.1-79.1-79.1c-8.2-8.2-8.2-21.4 0-29.6 3.9-4 9.2-6.1 14.8-6.1 5.6 0 10.8 2.2 14.8 6.1l79.1 79.1 79.1-79.1c4-4 9.2-6.1 14.8-6.1 5.6 0 10.8 2.2 14.8 6.1 4 3.9 6.1 9.2 6.1 14.8 0 5.6-2.2 10.8-6.1 14.8L323.5 294l79.1 79.1c4 4 6.1 9.2 6.1 14.8.1 5.5-2.1 10.8-6.1 14.7z\"></path><path d=\"M403.3 372.3L325 294l78.4-78.4c4.1-4.1 6.4-9.7 6.4-15.5 0-5.9-2.3-11.4-6.4-15.5-4.1-4.1-9.6-6.4-15.5-6.4s-11.4 2.3-15.5 6.4L294 263l-78.4-78.4c-4.1-4.1-9.7-6.4-15.5-6.4-5.9 0-11.4 2.3-15.5 6.4-8.5 8.5-8.5 22.5 0 31L263 294l-78.4 78.4c-4.1 4.1-6.4 9.6-6.4 15.5s2.3 11.4 6.4 15.5c4.1 4.1 9.6 6.4 15.5 6.4 5.8 0 11.4-2.3 15.5-6.4L294 325l78.4 78.4c4.1 4.1 9.6 6.4 15.5 6.4s11.4-2.3 15.5-6.4c4.1-4.1 6.4-9.6 6.4-15.5s-2.3-11.4-6.5-15.6zm-15.5 36.5c-5.6 0-10.8-2.2-14.8-6.1l-79-79.2-79.1 79.1c-4 4-9.2 6.1-14.8 6.1-5.6 0-10.8-2.2-14.8-6.1-4-4-6.1-9.2-6.1-14.8 0-5.6 2.2-10.8 6.1-14.8l79.1-79.1-79.1-79.1c-8.2-8.2-8.2-21.4 0-29.6 3.9-4 9.2-6.1 14.8-6.1 5.6 0 10.8 2.2 14.8 6.1l79.1 79.1 79.1-79.1c4-4 9.2-6.1 14.8-6.1 5.6 0 10.8 2.2 14.8 6.1 4 3.9 6.1 9.2 6.1 14.8 0 5.6-2.2 10.8-6.1 14.8L323.5 294l79.1 79.1c4 4 6.1 9.2 6.1 14.8 0 5.6-2.2 10.8-6.1 14.8-3.9 3.9-9.2 6.1-14.8 6.1z\"></path><path d=\"M402.6 373c4 4 6.1 9.2 6.1 14.8 0 5.6-2.2 10.8-6.1 14.8-4 4-9.2 6.1-14.8 6.1-5.6 0-10.8-2.2-14.8-6.1l-79-79.1-79.1 79.1c-4 4-9.2 6.1-14.8 6.1-5.6 0-10.8-2.2-14.8-6.1-4-4-6.1-9.2-6.1-14.8 0-5.6 2.2-10.8 6.1-14.8l79.1-79.1-79.1-79.1c-8.2-8.2-8.2-21.4 0-29.6 3.9-4 9.2-6.1 14.8-6.1 5.6 0 10.8 2.2 14.8 6.1l79.1 79.1 79.1-79.1c4-4 9.2-6.1 14.8-6.1 5.6 0 10.8 2.2 14.8 6.1 4 3.9 6.1 9.2 6.1 14.8 0 5.6-2.2 10.8-6.1 14.8L323.5 294l79.1 79z\"></path></svg>", 1);
const _hoisted_3$3 = [
  _hoisted_2$3
];
const _hoisted_4$3 = /*#__PURE__*/createElementVNode("h2", { class: "visually-hidden" }, "Statusbericht", -1 /* HOISTED */);
const _hoisted_5$3 = { class: "content pr-4 pl-3" };

function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", _hoisted_1$4, [
    createElementVNode("button", {
      type: "button",
      class: "close",
      "data-dismiss": "alert",
      "aria-label": "Close",
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.hideToast()))
    }, _hoisted_3$3),
    _hoisted_4$3,
    createElementVNode("div", _hoisted_5$3, toDisplayString(_ctx.label), 1 /* TEXT */)
  ]))
}

script$5.render = render$5;
script$5.__file = "src/components/toast/SuccessToast.vue";

var script$4 = defineComponent({
    name: 'BreadCrumb',
    props: {
        home: {
            type: String,
            required: false,
            default: '/'
        },
        route: {
            type: Object,
            required: true
        },
        router: {
            type: Object,
            required: true
        },
        isInternetActive: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    setup: function (props) {
        var route = props.route;
        var breadcrumbs = ref([]);
        var navigateHome = function () {
            props.router.push(props.home);
        };
        var navigateToCrumb = function (selectedBreadcrumb) {
            var link = '';
            for (var i = 0; i < breadcrumbs.value.length; i++) {
                link += '/' + breadcrumbs.value[i].crumb + '/' + (breadcrumbs.value[i].uuid ? breadcrumbs.value[i].uuid : '');
                if (breadcrumbs.value[i].crumb === selectedBreadcrumb.crumb) {
                    break;
                }
            }
            props.router.push(link);
        };
        watch(function () { return route.path; }, function () {
            breadcrumbs.value = [];
            var splittedValues = route.path.split('/');
            var t = {};
            var regexHasUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/;
            splittedValues.forEach(function (splittedValue) {
                if (splittedValue.length > 0) {
                    if (!regexHasUuid.test(splittedValue)) {
                        t.crumb = splittedValue;
                    }
                    if (regexHasUuid.test(splittedValue)) {
                        t.uuid = splittedValue;
                        breadcrumbs.value.push({ crumb: decodeURI(t.crumb ? t.crumb : ''), uuid: t.uuid });
                        console.log('breadcrumbs: ', breadcrumbs.value);
                    }
                }
            });
        });
        return {
            route: route,
            breadcrumbs: breadcrumbs,
            navigateHome: navigateHome,
            navigateToCrumb: navigateToCrumb
        };
    }
});

const _hoisted_1$3 = {
  role: "navigation",
  "aria-labelledby": "system-breadcrumb",
  class: "breadcrumb-wrapper__nav"
};
const _hoisted_2$2 = /*#__PURE__*/createElementVNode("h2", {
  id: "system-breadcrumb",
  class: "visually-hidden"
}, "Kruimelpad", -1 /* HOISTED */);
const _hoisted_3$2 = { class: "flex justify-between" };
const _hoisted_4$2 = { class: "breadcrumb" };
const _hoisted_5$2 = /*#__PURE__*/createStaticVNode("<a class=\"breadcrumb-item--home flex items-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><g data-name=\"Layer 2\"><path d=\"M20.42 10.18L12.71 2.3a1 1 0 00-1.42 0l-7.71 7.89A2 2 0 003 11.62V20a2 2 0 001.89 2h14.22A2 2 0 0021 20v-8.38a2.07 2.07 0 00-.58-1.44zM10 20v-6h4v6zm9 0h-3v-7a1 1 0 00-1-1H9a1 1 0 00-1 1v7H5v-8.42l7-7.15 7 7.19z\" data-name=\"home\"></path></g></svg><span class=\"ml-1 d-none d-lg-inline-block\">Home</span></a>", 1);
const _hoisted_6$2 = [
  _hoisted_5$2
];
const _hoisted_7$2 = ["onClick"];
const _hoisted_8$2 = { key: 0 };
const _hoisted_9$2 = { class: "pr-2" };
const _hoisted_10$1 = {
  key: 0,
  class: "fill-current text-green",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "24px",
  height: "24px"
};
const _hoisted_11$1 = /*#__PURE__*/createElementVNode("g", { "data-name": "Layer 99" }, [
  /*#__PURE__*/createElementVNode("path", {
    d: "M12,21L15.6,16.2C14.6,15.45 13.35,15 12,15C10.65,15 9.4,15.45 8.4,16.2L12,21M12,3C7.95,3 4.21,4.34 1.2,6.6L3,9C5.5,7.12 8.62,6 12,6C15.38,6 18.5,7.12 21,9L22.8,6.6C19.79,4.34 16.05,3 12,3M12,9C9.3,9 6.81,9.89 4.8,11.4L6.6,13.8C8.1,12.67 9.97,12 12,12C14.03,12 15.9,12.67 17.4,13.8L19.2,11.4C17.19,9.89 14.7,9 12,9Z",
    "data-name": "wifi"
  })
], -1 /* HOISTED */);
const _hoisted_12$1 = [
  _hoisted_11$1
];
const _hoisted_13 = /*#__PURE__*/createElementVNode("svg", {
  class: "fill-current text-red",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "24px",
  height: "24px"
}, [
  /*#__PURE__*/createElementVNode("g", { "data-name": "Layer 100" }, [
    /*#__PURE__*/createElementVNode("path", {
      d: "M2.28,3L1,4.27L2.47,5.74C2.04,6 1.61,6.29 1.2,6.6L3,9C3.53,8.6 4.08,8.25 4.66,7.93L6.89,10.16C6.15,10.5 5.44,10.91 4.8,11.4L6.6,13.8C7.38,13.22 8.26,12.77 9.2,12.47L11.75,15C10.5,15.07 9.34,15.5 8.4,16.2L12,21L14.46,17.73L17.74,21L19,19.72M12,3C9.85,3 7.8,3.38 5.9,4.07L8.29,6.47C9.5,6.16 10.72,6 12,6C15.38,6 18.5,7.11 21,9L22.8,6.6C19.79,4.34 16.06,3 12,3M12,9C11.62,9 11.25,9 10.88,9.05L14.07,12.25C15.29,12.53 16.43,13.07 17.4,13.8L19.2,11.4C17.2,9.89 14.7,9 12,9Z",
      "data-name": "wifi-off"
    })
  ])
], -1 /* HOISTED */);

function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("nav", _hoisted_1$3, [
    _hoisted_2$2,
    createElementVNode("ol", _hoisted_3$2, [
      createElementVNode("div", _hoisted_4$2, [
        createCommentVNode(" HOME "),
        createElementVNode("li", {
          class: "breadcrumb-item cursor-pointer",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.navigateHome()))
        }, _hoisted_6$2),
        createCommentVNode(" CRUMBS "),
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.breadcrumbs, (breadcrumb) => {
          return (openBlock(), createElementBlock("li", {
            onClick: $event => (_ctx.navigateToCrumb(breadcrumb)),
            key: breadcrumb,
            class: "breadcrumb-item active cursor-pointer"
          }, [
            (breadcrumb && breadcrumb.crumb)
              ? (openBlock(), createElementBlock("a", _hoisted_8$2, toDisplayString(breadcrumb.crumb), 1 /* TEXT */))
              : createCommentVNode("v-if", true)
          ], 8 /* PROPS */, _hoisted_7$2))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      createElementVNode("div", _hoisted_9$2, [
        createCommentVNode(" WIFI ON  "),
        (_ctx.isInternetActive)
          ? (openBlock(), createElementBlock("svg", _hoisted_10$1, _hoisted_12$1))
          : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createCommentVNode(" WIFI OFF "),
              _hoisted_13
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
      ])
    ])
  ]))
}

script$4.render = render$4;
script$4.__file = "src/components/breadcrumb/Breadcrumb.vue";

var InputTypes;
(function (InputTypes) {
    InputTypes["DATE_TIME_LOCAL"] = "datetime-local";
    InputTypes["TEXT_AREA"] = "textarea";
    InputTypes["CHECK"] = "checkbox";
    InputTypes["NUMBER"] = "number";
    InputTypes["DATE"] = "date";
    InputTypes["TIME"] = "time";
    InputTypes["TEXT"] = "text";
    InputTypes["TEL"] = "tel";
    InputTypes["RADIO"] = "radio";
})(InputTypes || (InputTypes = {}));

var script$3 = defineComponent({
    name: 'Required',
    props: {
        rules: {
            type: [Object, String, Function],
            default: '',
            required: false
        }
    }
});

const _hoisted_1$2 = {
  key: 0,
  class: "text-red ml-1"
};

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.rules.includes('required') || _ctx.rules.includes('customRequired'))
    ? (openBlock(), createElementBlock("label", _hoisted_1$2, "*"))
    : createCommentVNode("v-if", true)
}

script$3.render = render$3;
script$3.__file = "src/components/required/Required.vue";

var script$2 = defineComponent({
    name: 'CustomInput',
    components: {
        ErrorMessage: ErrorMessage,
        Required: script$3
    },
    props: {
        modelValue: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        },
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: false,
            default: InputTypes.TEXT
        },
        value: {
            type: String,
            default: ''
        },
        rules: {
            type: [Object, String, Function],
            default: '',
            required: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        min: {
            type: String,
            required: false,
            default: ''
        },
        maxlength: {
            type: String,
            required: false,
            default: '1000'
        },
        extraInfo: {
            type: String,
            required: false
        },
        hideInput: {
            type: Boolean,
            default: false,
            required: false
        },
        loadingSubmit: {
            type: Boolean,
            default: false,
            required: false
        },
        onInvalid: {
            type: String,
            default: '',
            required: false
        },
        textAreaWidth: {
            type: String,
            required: false,
            default: 'w-96'
        },
        placeholder: {
            type: String,
            required: false
        },
        step: {
            type: String,
            required: false
        },
        isSubmitting: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: ['update:modelValue'],
    setup: function (props, context) {
        var modelValue = toRefs(props).modelValue;
        if (props.type !== InputTypes.CHECK) {
            var inputValue_1 = useField(props.name, props.rules, {
                initialValue: props.value
            }).value;
            var cardNumberSpace_1 = function () {
                if (props.name === 'victim.bankAccount') {
                    inputValue_1.value = inputValue_1.value
                        .replace(/[^\dA-Z]/g, '')
                        .replace(/(.{4})/g, '$1 ')
                        .trim();
                }
            };
            watch(function () { return inputValue_1.value; }, function () {
                cardNumberSpace_1();
            });
            return {
                InputTypes: InputTypes,
                inputValue: inputValue_1
            };
        }
        else {
            // IF THE TYPE IS A CHECKBOX IS DOES NOT NEED A USEFIELD FOR VEE VALIDATE
            var emitValue = function () {
                if (modelValue.value.includes(props.name)) {
                    modelValue.value.splice(modelValue.value.indexOf(props.name), 1);
                }
                else {
                    modelValue.value.push(props.name);
                }
                context.emit('update:modelValue', modelValue.value);
            };
            return {
                InputTypes: InputTypes,
                emitValue: emitValue
            };
        }
    }
});

const _hoisted_1$1 = { key: 0 };
const _hoisted_2$1 = {
  key: 1,
  style: {"font-size":"13px"}
};
const _hoisted_3$1 = ["min", "type", "maxlength", "name", "disabled", "placeholder"];
const _hoisted_4$1 = ["id", "name", "disabled", "step"];
const _hoisted_5$1 = ["name", "disabled"];
const _hoisted_6$1 = { key: 3 };
const _hoisted_7$1 = ["id", "type", "name", "value"];
const _hoisted_8$1 = ["for"];
const _hoisted_9$1 = ["name"];

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_required = resolveComponent("required");
  const _component_ErrorMessage = resolveComponent("ErrorMessage");

  return (openBlock(), createElementBlock("div", null, [
    (!_ctx.hideInput && _ctx.label && _ctx.type !== _ctx.InputTypes.CHECK)
      ? (openBlock(), createElementBlock("strong", _hoisted_1$1, [
          createElementVNode("p", null, [
            createTextVNode(toDisplayString(_ctx.label) + " ", 1 /* TEXT */),
            createVNode(_component_required, { rules: _ctx.rules }, null, 8 /* PROPS */, ["rules"])
          ])
        ]))
      : createCommentVNode("v-if", true),
    (_ctx.extraInfo)
      ? (openBlock(), createElementBlock("div", _hoisted_2$1, [
          createElementVNode("label", null, toDisplayString(_ctx.extraInfo), 1 /* TEXT */)
        ]))
      : createCommentVNode("v-if", true),
    createElementVNode("div", null, [
      renderSlot(_ctx.$slots, "default")
    ]),
    createElementVNode("div", {
      class: normalizeClass({
        'text-lightGray animate-pulse2 bg-lightGray': _ctx.isSubmitting
      })
    }, [
      (_ctx.type !== _ctx.InputTypes.TEXT_AREA && !_ctx.hideInput && _ctx.type !== _ctx.InputTypes.TIME && _ctx.type !== _ctx.InputTypes.CHECK)
        ? withDirectives((openBlock(), createElementBlock("input", {
            key: 0,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.inputValue) = $event)),
            class: normalizeClass(["bg-lightGray p-2 min-w-0 w-100", { 'opacity-0': _ctx.isSubmitting }]),
            min: _ctx.min,
            type: _ctx.type,
            step: "1",
            maxlength: _ctx.maxlength,
            name: _ctx.name,
            disabled: _ctx.disabled || _ctx.isSubmitting,
            placeholder: _ctx.placeholder
          }, null, 10 /* CLASS, PROPS */, _hoisted_3$1)), [
            [vModelDynamic, _ctx.inputValue]
          ])
        : createCommentVNode("v-if", true),
      (_ctx.type === _ctx.InputTypes.TIME)
        ? withDirectives((openBlock(), createElementBlock("input", {
            key: 1,
            id: _ctx.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.inputValue) = $event)),
            class: normalizeClass(["bg-lightGray p-2 min-w-0 w-100", { 'opacity-0': _ctx.isSubmitting }]),
            style: {"max-width":"100px"},
            type: "time",
            name: _ctx.name,
            disabled: _ctx.disabled || _ctx.isSubmitting,
            step: _ctx.step
          }, null, 10 /* CLASS, PROPS */, _hoisted_4$1)), [
            [vModelText, _ctx.inputValue]
          ])
        : createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    (_ctx.type === _ctx.InputTypes.TEXT_AREA && !_ctx.hideInput && _ctx.type !== _ctx.InputTypes.TIME)
      ? withDirectives((openBlock(), createElementBlock("textarea", {
          key: 2,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.inputValue) = $event)),
          class: normalizeClass(["bg-lightGray p-2 h-32", 'md:' + _ctx.textAreaWidth + ' ' + 'xs:w-full']),
          type: 'text',
          name: _ctx.name,
          maxlength: "500",
          disabled: _ctx.disabled || _ctx.isSubmitting
        }, null, 10 /* CLASS, PROPS */, _hoisted_5$1)), [
          [vModelText, _ctx.inputValue]
        ])
      : createCommentVNode("v-if", true),
    createCommentVNode(" CHECKBOX "),
    (_ctx.type === _ctx.InputTypes.CHECK && !_ctx.hideInput)
      ? (openBlock(), createElementBlock("div", _hoisted_6$1, [
          createElementVNode("input", {
            id: 'checkbox-' + _ctx.name,
            class: "cursor-pointer",
            type: _ctx.InputTypes.CHECK,
            name: 'checkbox-' + _ctx.name,
            value: _ctx.name,
            onChange: _cache[3] || (_cache[3] = $event => (_ctx.emitValue()))
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_7$1),
          createElementVNode("label", {
            for: 'checkbox-' + _ctx.name,
            class: "ml-2 cursor-pointer"
          }, toDisplayString(_ctx.label), 9 /* TEXT, PROPS */, _hoisted_8$1)
        ]))
      : createCommentVNode("v-if", true),
    createElementVNode("span", { name: _ctx.name }, [
      createVNode(_component_ErrorMessage, {
        name: _ctx.name,
        class: "text-red text-sm block mt-1 w-80"
      }, null, 8 /* PROPS */, ["name"])
    ], 8 /* PROPS */, _hoisted_9$1)
  ]))
}

script$2.render = render$2;
script$2.__file = "src/components/inputs/CustomInput.vue";

var script$1 = defineComponent({
    name: 'BasePage'
});

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", null, [
    renderSlot(_ctx.$slots, "default")
  ]))
}

script$1.render = render$1;
script$1.__file = "src/components/basePage/BasePage.vue";

var script = defineComponent({
    name: 'Warning',
    components: {
        'custom-button': script$8,
        loader: script$a
    },
    props: {
        title: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        isDisplayed: {
            type: Boolean,
            required: true
        },
        color: {
            type: String,
            required: false,
            default: 'red'
        },
        leftButton: {
            type: String,
            required: false
        },
        rightButton: {
            type: String,
            required: false
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: ['leftButtonClicked', 'rightButtonClicked'],
    setup: function (props, context) {
        var rightButtonClicked = function () {
            context.emit('rightButtonClicked', true);
        };
        var leftButtonClicked = function () {
            context.emit('leftButtonClicked', true);
        };
        return {
            rightButtonClicked: rightButtonClicked,
            leftButtonClicked: leftButtonClicked
        };
    }
});

const _hoisted_1 = {
  key: 0,
  class: "h-full w-full fixed top-0 left-0 overflow-x-hidden bg-black bg-opacity-20 z-40"
};
const _hoisted_2 = { class: "flex h-screen justify-center items-center" };
const _hoisted_3 = { class: "align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" };
const _hoisted_4 = {
  key: 0,
  class: "h-full w-full fixed top-0 left-0 overflow-x-hidden bg-black bg-opacity-20"
};
const _hoisted_5 = { class: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" };
const _hoisted_6 = { class: "sm:flex sm:items-start" };
const _hoisted_7 = /*#__PURE__*/createElementVNode("svg", {
  class: "h-6 w-6 text-red",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
  })
], -1 /* HOISTED */);
const _hoisted_8 = [
  _hoisted_7
];
const _hoisted_9 = { class: "text-center sm:mt-0 sm:ml-4 sm:text-left" };
const _hoisted_10 = {
  class: "text-lg text-left leading-6 font-medium text-darkGray",
  id: "modal-title"
};
const _hoisted_11 = { class: "text-sm text-left text-darkGray" };
const _hoisted_12 = {
  key: 1,
  class: "bg-gray px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse gap-3"
};

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loader = resolveComponent("loader");
  const _component_custom_button = resolveComponent("custom-button");

  return (_ctx.isDisplayed)
    ? (openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("div", _hoisted_2, [
          createElementVNode("div", _hoisted_3, [
            (_ctx.isLoading)
              ? (openBlock(), createElementBlock("div", _hoisted_4, [
                  createElementVNode("div", _hoisted_5, [
                    createVNode(_component_loader, {
                      size: "10",
                      isLoading: _ctx.isLoading,
                      color: "white"
                    }, null, 8 /* PROPS */, ["isLoading"])
                  ])
                ]))
              : createCommentVNode("v-if", true),
            createElementVNode("div", {
              class: normalizeClass(["bg-white px-4 pb-4 sm:p-6 sm:pb-4", _ctx.leftButton || _ctx.rightButton ? 'pt-5' : 'mt-2'])
            }, [
              createElementVNode("div", _hoisted_6, [
                createElementVNode("div", {
                  class: normalizeClass([_ctx.title && 'mt-2', "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-lightRed sm:mx-0 sm:h-10 sm:w-10"])
                }, _hoisted_8, 2 /* CLASS */),
                createElementVNode("div", _hoisted_9, [
                  createElementVNode("h3", _hoisted_10, toDisplayString(_ctx.title), 1 /* TEXT */),
                  createElementVNode("div", null, [
                    createElementVNode("p", _hoisted_11, toDisplayString(_ctx.text), 1 /* TEXT */)
                  ])
                ])
              ])
            ], 2 /* CLASS */),
            (_ctx.leftButon || _ctx.rightButton)
              ? (openBlock(), createElementBlock("div", _hoisted_12, [
                  (_ctx.rightButton)
                    ? (openBlock(), createBlock(_component_custom_button, {
                        key: 0,
                        disabled: _ctx.isLoading,
                        onClick: _cache[0] || (_cache[0] = $event => (_ctx.rightButtonClicked())),
                        class: "w-full inline-flex justify-center sm:w-auto",
                        text: _ctx.rightButton,
                        type: "button"
                      }, null, 8 /* PROPS */, ["disabled", "text"]))
                    : createCommentVNode("v-if", true),
                  (_ctx.leftButton)
                    ? (openBlock(), createBlock(_component_custom_button, {
                        key: 1,
                        disabled: _ctx.isLoading,
                        onClick: _cache[1] || (_cache[1] = $event => (_ctx.leftButtonClicked())),
                        class: "w-full inline-flex justify-center sm:w-auto",
                        text: _ctx.leftButton,
                        type: "button"
                      }, null, 8 /* PROPS */, ["disabled", "text"]))
                    : createCommentVNode("v-if", true)
                ]))
              : createCommentVNode("v-if", true)
          ])
        ])
      ]))
    : createCommentVNode("v-if", true)
}

script.render = render;
script.__file = "src/components/modals/Warning.vue";

var scrollToFirstError = function (validation, container) {
    if (validation.valid) {
        return;
    }
    var el = null;
    var errors = validation.errors;
    if (errors) {
        var first = Object.keys(errors)[0];
        if (first) {
            if (!el) {
                el = document.querySelector('#' + container + ' input[name="' + first + '"]');
            }
            if (!el) {
                el = document.querySelector('#' + container + ' span[name="' + first + '"]');
            }
            if (!el) {
                el = document.querySelector('#' + container + ' #' + first);
            }
        }
    }
    if (el) {
        el = el.parentElement;
        if (el) {
            el.scrollIntoView();
        }
    }
};
var useScrollToTop = function () {
    var formDiv = ref(undefined);
    var scrollToTop = function () {
        if (formDiv.value) {
            formDiv.value.scrollTop = 0;
        }
    };
    var scrollToTopOfPage = function () {
        window.scrollTo({ top: 0, behavior: 'auto' });
    };
    return {
        formDiv: formDiv,
        scrollToTop: scrollToTop,
        scrollToTopOfPage: scrollToTopOfPage
    };
};
var useFormSendWithSuccess = function (meta) {
    var formSendWithSuccess = ref(false);
    if (meta) {
        watch(meta, function (value) {
            if (value.dirty) {
                formSendWithSuccess.value = false;
            }
        });
    }
    return {
        formSendWithSuccess: formSendWithSuccess
    };
};

var defineRules = function () {
    defineRule('required', required);
    defineRule('email', email);
    configure({
        // Generates an English message locale generator
        // https://vee-validate.logaretm.com/v4/guide/i18n#global-message-generator
        generateMessage: localize({
            en: {
                messages: {
                    required: 'This field is required',
                    email: 'Not a valid email',
                }
            },
            nl: {
                messages: {
                    required: 'Dit veld is verplicht',
                    email: 'Geen geldig email'
                }
            }
        })
    });
    // KAMPVISUM
    defineRule('minimumOneSection', function (value) {
        if (value.length === 0) {
            return 'Selecteer er minstens 1.';
        }
        return true;
    });
    defineRule('oneSection', function (value) {
        if (value.length === 0) {
            return 'Selecteer 1 tak.';
        }
        else if (1 < value.length) {
            return 'Selecteer 1 tak. Maak een apart kamp voor elke tak.';
        }
        return true;
    });
    setLocale('nl');
};

export { script$1 as BasePage, script$6 as BaseSideBar, script$4 as Breadcrumb, script$8 as CustomButton, script$9 as CustomButtonSmall, script$7 as CustomHeader, script$2 as CustomInput, InputTypes, script$a as Loader, script$3 as Required, script$b as ScoutsDummyBar, script$5 as SuccessToast, script as Warning, defineRules, scrollToFirstError, useFormSendWithSuccess, useScrollToTop };
//# sourceMappingURL=index.esm.js.map
